import { render, staticRenderFns } from "./TDatePickerSettingPanel.vue?vue&type=template&id=36e0737e&"
import script from "./TDatePickerSettingPanel.vue?vue&type=script&lang=js&"
export * from "./TDatePickerSettingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
